module.exports = __webpack_public_path__ + "static/media/star-fh.75aa2a61.png";